import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { SORTABLE_TENDERS_COLUMNS, TendersSearchParams } from 'src/models/procurements/Tenders/types';
import PlainDropDown from 'src/common/PlainDropDown';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import { TendersSortName, TendersSortOrder } from 'src/models/procurements/Tenders/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownWideShort, faArrowUpWideShort } from '@fortawesome/pro-light-svg-icons';

const FilterSort: FC = () => {
  const { t } = useTranslation();
  const [{ initVars, vars: args }, setSorting] = useApiTenders();

  const onChangeSortColumn = useCallback(
    (item: TendersSortName) => {
      const sort = args.sort ? args.sort : initVars.sort;
      sort && setSorting({ [TendersSearchParams.sort]: { ...sort, key: item } });
    },
    [args.sort, initVars.sort, setSorting]
  );
  const values = useMemo(
    () =>
      SORTABLE_TENDERS_COLUMNS.map(column => {
        const label = Object.keys(TendersSortName).find(
          key => TendersSortName[key as keyof typeof TendersSortName] === column
        );
        return {
          value: column,
          label: label ? t(`Tenders.TendersSort.${label}`) : undefined
        };
      }),
    [t]
  );

  const isAscending = useMemo(() => args.sort?.sort === TendersSortOrder.ASCENDING, [args.sort?.sort]);
  const onClick = useCallback(() => {
    const sort = args.sort ? args.sort : initVars.sort;
    sort &&
      setSorting({
        [TendersSearchParams.sort]: {
          ...sort,
          sort: isAscending ? TendersSortOrder.DESCENDING : TendersSortOrder.ASCENDING
        }
      });
  }, [args.sort, isAscending, initVars.sort, setSorting]);

  return (
    <div className={styles.container}>
      <PlainDropDown
        values={values}
        selectedValue={args.sort?.key as TendersSortName}
        label={t('Common.sortBy')}
        onSelect={onChangeSortColumn}
        type="single"
      />
      <button className={styles.button} onClick={onClick}>
        <FontAwesomeIcon icon={isAscending ? faArrowDownWideShort : faArrowUpWideShort} className={styles.icon} />
      </button>
    </div>
  );
};

export default FilterSort;
